import React, {Component} 			from 'react';
import propTypes 					from 'prop-types';
import IconValueLeft 				from 'fdna-common-components/dist/components/Icon/IconValue/IconValueLeft'
import noop 						from 'lodash/noop';
import pick 						from 'lodash/pick';
import isString 					from 'lodash/isString';

export default class ListItemCheckbox extends Component{

	constructor(props, context){
		super(props, context);

		this.onClick = this.onClick.bind(this);
	}

	onClick(event){
		const {option, removeValue, selectValue} = this.props;
		if (option.isSelected) {
			removeValue(option);
		} else {
			selectValue(option);
		}
	}

	render(){
		const label = this.props.option[this.context.labelKey];
		const props = pick(this.props, ['onClick', 'onSelect', 'onFocus', 'className']);
		const icon = this.props.isSelected ? "img/icoCheckboxChecked.png" : "img/icoCheckboxUnChecked.png";

		return (
			<div {...props} onClick={this.onClick} >
				<IconValueLeft icon={icon} >
					{ label }
				</IconValueLeft>
			</div>
		);
	}
}

ListItemCheckbox.contextTypes = {
	valueKey: propTypes.string,
	labelKey: propTypes.string,
};


// WEBPACK FOOTER //
// ./common/components/ListItemCheckbox/ListItemCheckbox.jsx